import React, { useState, useEffect } from "react";
import { useDebounce } from "use-debounce";

import { Barber } from "../../types";
import { searchBarbers } from "./utils";

interface BarberSearchResults {
  results: Barber[];
  hasResults: boolean;
  query: string;
  setQuery: React.Dispatch<React.SetStateAction<string>>;
  hasQuery: boolean;
}

export const useBarberSearch = (
  barbers: Barber[],
  debounceDelay: number = 500
): BarberSearchResults => {
  const [results, setResults] = useState(barbers);
  const hasResults = !!(results && results.length);
  const [query, setQuery] = useState("");
  const [debouncedQuery] = useDebounce(query, debounceDelay);
  const hasQuery = debouncedQuery.length > 0;

  useEffect(() => {
    const queryResult = searchBarbers(debouncedQuery, barbers);

    setResults(queryResult);
  }, [barbers, debouncedQuery]);

  return { results, hasResults, query, setQuery, hasQuery };
};
